import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Button } from './Button';
const painPoints = ['Tenés un buen producto o servicio, pero casi nadie lo conoce online.', 'Publicás en redes, pero no conseguís clientes ni ventas constantes.', 'Probaste hacer anuncios y sentiste que solo perdiste plata.', 'Te escriben por WhatsApp, preguntan precio… y después desaparece.', 'Ves que otros venden por internet y no entendés qué están haciendo distinto.', 'Querés usar IA para vender mejor, pero no sabés por dónde empezar.', 'Invertís tiempo y plata pero no sabés qué está fallando ni cómo corregirlo.'];
export function PainPoints() {
  return <section className="py-10 sm:py-16 px-4 bg-green-950/40 border-y border-green-700/20" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 5
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10px'
      }} transition={{
        duration: 0.2
      }} data-id="element-154">
          <h2 className="text-3xl sm:text-4xl font-black text-center text-white mb-6 sm:mb-10 drop-shadow-lg uppercase" data-id="element-155">
            ¿TE IDENTIFICÁS CON ALGUNA DE ESTAS SITUACIONES?
          </h2>

          <div className="space-y-3 mb-8" data-id="element-156">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.2,
            delay: index * 0.05
          }} className="flex items-start gap-4 bg-green-950/50 p-5 rounded-xl border border-green-700/20" data-id="element-157">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-158" />
                <p className="text-lg text-white font-medium" data-id="element-159">{point}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}